import makeUseGlobalClientState from 'ui-library/hooks/global-client-state/makeUseGlobalClientState';

interface AntibodyUIState {
  openVersionId: string | null;
}

export const DEFAULT_ANTIBODY_UI_STATE: AntibodyUIState = {
  openVersionId: null,
};

export const antibodyUIStateHook = makeUseGlobalClientState<AntibodyUIState>(DEFAULT_ANTIBODY_UI_STATE);

/**
 * Updates the open version ID for an antibody.
 * This should be used when updating the open version ID outside of a component. Otherwise, prefer the
 * useAntibodyUIState hook.
 */
export const updateAntibodyUIOpenVersionId = (antibodyId: string, openVersionId: string): void => {
  antibodyUIStateHook.updateState(`antibody-ui-${antibodyId}`, {openVersionId});
};

/**
 * Whether a given entity ID has antibody UI state, indicating that it has been opened and is an antibody.
 */
export function hasOpenedAsAntibody(entityId: string | null): boolean {
  return antibodyUIStateHook.getState(`antibody-ui-${entityId}`).openVersionId != null;
}

export default function useAntibodyUIState(antibodyId: string): {
  state: AntibodyUIState;
  setOpenVersionId: (openVersionId: string) => void;
} {
  const [state, setState] = antibodyUIStateHook.useGlobalClientState(`antibody-ui-${antibodyId}`);
  return {
    state,
    setOpenVersionId: (openVersionId: string): void => {
      setState({openVersionId});
    },
  };
}
